import React, { useCallback, useEffect, useState } from 'react'
import { NameDto } from 'api/Common/Types'
import {
  PaymentProviderGroupDto,
  PSPGroupTypes,
  PSPMethodTypes,
  UpdatePaymentProviderGroupDto,
} from 'api/PaymentProvider/Types/PaymentProviderGroupDto'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { EditPaymentProviderGroupForm } from './EditPaymentProviderForm'

interface Props {
  data?: PaymentProviderGroupDto
  onCloseModal(): void
  onSubmit(values: UpdatePaymentProviderGroupDto): void
  uncovered?: boolean
}

const EditPaymentProviderPage: React.FC<Props> = ({ data, onSubmit, uncovered, onCloseModal }) => {
  const walletsApiClient = useApiClient(WalletsApiClient)

  const [isLoading, setLoading] = useState(false)
  const [withdrawalMethodOptions, setWithdrawalMethodOptions] = useState<NameDto<string>[]>()
  const [depositMethodOptions, setDepositMethodOptions] = useState<NameDto<string>[]>()
  const [uncoveredMethodOptions, setUncoveredMethodOptions] = useState<NameDto<string>[]>()

  const getMethods = useCallback(async () => {
    try {
      setLoading(true)

      const availablePaymentProviderOptions =
        await walletsApiClient.getAvailablePaymentProviderOptions()
      if (!data?.methods) {
        setDepositMethodOptions(availablePaymentProviderOptions)
        setWithdrawalMethodOptions(availablePaymentProviderOptions)
        setUncoveredMethodOptions(availablePaymentProviderOptions)
      } else if (data.pspGroupType.id === PSPGroupTypes.DepositWithdraw) {
        const existingDepositMethods = data.methods
          .filter((method) => method.methodType.id === PSPMethodTypes.Deposit)
          .map((method) => method.paymentProvider)
        const existingWithdrawMethods = data.methods
          .filter((method) => method.methodType.id === PSPMethodTypes.Withdraw)
          .map((method) => method.paymentProvider)
        setDepositMethodOptions([...availablePaymentProviderOptions, ...existingDepositMethods])
        setWithdrawalMethodOptions([...availablePaymentProviderOptions, ...existingWithdrawMethods])
      } else {
        const existingUncoveredMethods = data.methods
          .filter((method) => method.methodType.id === PSPMethodTypes.Uncovered)
          .map((method) => method.paymentProvider)
        setUncoveredMethodOptions([...availablePaymentProviderOptions, ...existingUncoveredMethods])
      }
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getMethods()
  }, [])

  useEffect(() => {
    console.log({ isLoading })
  }, [isLoading])

  return (
    <EditPaymentProviderGroupForm
      isOpen
      data={data}
      uncovered={uncovered}
      isLoading={isLoading}
      depositMethodOptions={depositMethodOptions}
      withdrawalMethodOptions={withdrawalMethodOptions}
      uncoveredMethodOptions={uncoveredMethodOptions}
      onClose={onCloseModal}
      onSubmit={onSubmit}
    />
  )
}

export default EditPaymentProviderPage
